import { createSelector } from '@reduxjs/toolkit';
import { authSelector } from 'store/selectors';
import { getProfileByToken } from 'utils/tokenProfile';

export const tokenSelector = createSelector(
  authSelector,
  (auth) => auth.token
);

export const profileSelector = createSelector(tokenSelector, (state) => getProfileByToken(state));